/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { templatesList } from "../funcs/templatesList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListPromptTemplatesResult } from "../models/components/listprompttemplatesresult.js";
import {
  ListTemplatesRequest,
  ListTemplatesSecurity,
} from "../models/operations/listtemplates.js";
import { unwrapAsync } from "../types/fp.js";
export type TemplatesQueryData = ListPromptTemplatesResult;

export function prefetchTemplates(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListTemplatesRequest | undefined,
  security?: ListTemplatesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildTemplatesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildTemplatesQuery(
  client$: GramCore,
  request?: ListTemplatesRequest | undefined,
  security?: ListTemplatesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<TemplatesQueryData>;
} {
  return {
    queryKey: queryKeyTemplates({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function templatesQueryFn(ctx): Promise<TemplatesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(templatesList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyTemplates(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "templates", "list", parameters];
}
